export default __webpack_public_path__ + "static/media/envsensor_realtime_humidity.124dfc24.svg";